import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbDateParserFormatter, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateParserFormatter } from '../shared/adapters/datepicker-adapter';
import { classSummaryModel } from './shared/models/classSummaryModel';
import { ClassSummaryService } from './shared/services/class-summary.service';

@Component({
  selector: 'app-class-summary',
  templateUrl: './class-summary.component.html',
  styleUrls: ['./class-summary.component.css'],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]
})
export class ClassSummaryComponent implements OnInit {

  classSummarySearchCriteria: classSummaryModel;
  InvoiceTypeId: number;
  code: string;
  invoiceTypeId: number;
  classSummaryResult: any;
  DateFrom: NgbDateStruct;
  DateTo: NgbDateStruct;
  maxDate: NgbDateStruct;

  constructor(private _modalSvc: NgbModal, private ClassSummaryService: ClassSummaryService) { }

  ngOnInit() {
    this.resetForm();
    const current = new Date();
    this.maxDate = { year: current.getFullYear(), month: current.getMonth() + 1, day: current.getDate() };
    this.ClassSummaryService.getClassSummary(this.classSummarySearchCriteria).subscribe(response => {
      if (response) {
        this.classSummaryResult = response;
        console.log(response);
      }

    });
  }

  resetForm() {
    let from = new Date();
    let to = new Date();
    from.setDate(from.getDate() - 7);
    this.DateFrom = { year: from.getFullYear(), month: from.getMonth() + 1, day: from.getDate() }
    this.DateTo = { year: to.getFullYear(), month: to.getMonth() + 1, day: to.getDate() },
      this.classSummarySearchCriteria = {
        DateFrom: (from.getMonth() + 1) + '/' + from.getDate() + '/' + from.getFullYear(),
        DateTo: (to.getMonth() + 1) + '/' + to.getDate() + '/' + to.getFullYear(),
        PageNo: 1,
        PageSize: 10,
        Code: '',
        InvoiceTypeId: 0

      };
    this.code = this.classSummarySearchCriteria.Code;
    this.invoiceTypeId = this.classSummarySearchCriteria.InvoiceTypeId;
  }

  cancelSearch() {
    this.ngOnInit();

  }

  getSearch(PageNo: number) {
    this.classSummarySearchCriteria.Code = null;
    this.classSummarySearchCriteria.InvoiceTypeId = 0;
    this.classSummarySearchCriteria.DateFrom = this.DateFrom.month + '/' + this.DateFrom.day + '/' + this.DateFrom.year;
    this.classSummarySearchCriteria.DateTo = this.DateTo.month + '/' + this.DateTo.day + '/' + this.DateTo.year;
    this.ClassSummaryService.getClassSummary(this.classSummarySearchCriteria).subscribe(response => {
      if (response) {
        this.classSummaryResult = response;
        console.log(response);
      }
    });
  }


}
